class Header {
  init() {
    const headerButtonSearch = document.getElementById("header-btn-search");
    const hamburger = document.querySelector(".hamburger");
    const menuMobile = document.querySelector(".header-menu-mobile");
    const form = document.getElementById("searchform");
    const input = document.querySelector(".header-top__search-input");

    headerButtonSearch.addEventListener("click", () => {
      form.classList.add("header-top__form-active");
      headerButtonSearch.classList.add("header-top__btn-search__hide");
      input.focus();

      window.addEventListener("click", e => {
        if (
          !headerButtonSearch.contains(e.target) &&
          !form.contains(e.target) &&
          form.classList.contains("header-top__form-active")
        ) {
          form.classList.remove("header-top__form-active");
          headerButtonSearch.classList.remove("header-top__btn-search__hide");
        }
      });
    });

    hamburger.addEventListener("click", () => {
      hamburger.classList.toggle("is-active");
      menuMobile.classList.toggle("header-menu-mobile--active");
    });

    menuMobile.addEventListener("click", () => {
      hamburger.classList.remove("is-active");
      menuMobile.classList.remove("header-menu-mobile--active");
    });
  }
}

export default Header;
